import {MERGE_LANG, SET_LANG} from '../actions/action-types';

export const initialState = {};

const langReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LANG:
      return action.lang;
    case MERGE_LANG:
      return {...state, ...action.lang};
    default:
      return state;
  }
};

export default langReducer;
